import React from 'react'
import { useLocation } from 'react-router-dom';

const TableView = (props) => {

  const location = useLocation();
  const tableData = location.state?.tableData || [];
  console.log(props.tableData)


  const headerStyle = {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'center',
    fontWeight: 'bold',
    borderBottom: '2px solid #ddd',
  };

  const cellStyle = {
    padding: '8px',
    border: '1px solid #ddd',
    textAlign: 'center',
    backgroundColor: '#fff',
  };

  return (
    <>
      <div className="table-container">
        {/* <h4>Processed Files</h4> */}
        <div>
          <table>
            <thead>
              <tr>
                <th style={headerStyle}>Account ID</th>
                <th style={headerStyle}>FNO</th>
                <th style={headerStyle}>CM</th>
                <th style={headerStyle}>MCX</th>
                <th style={headerStyle}>Tot.CashAllocated</th>
                <th style={headerStyle}>Non MTF Cr</th>
                <th style={headerStyle}>Difference</th>
                <th style={headerStyle}>Net Credit</th>
                <th style={headerStyle}>CHEQ</th>

              </tr>
            </thead>
            <tbody>
              {tableData.map(({ accountId, foValue, cmValue, mcxValue, nonMcrValue, cashAllocated, result, netCredit,cheq }, index) => (
                <tr key={index}>

                  <td style={cellStyle}>{accountId}</td>
                  <td style={cellStyle}>{foValue}</td>
                  <td style={cellStyle}>{cmValue}</td>
                  <td style={cellStyle}>{mcxValue}</td>
                  <td style={cellStyle}>{cashAllocated}</td>
                  <td style={cellStyle}>{nonMcrValue}</td>
                  <td style={cellStyle}>{result}</td>
                  <td style={cellStyle}>{netCredit}</td>
                  <td style={cellStyle}>{cheq}</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </>
  )
}

export default TableView